(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-close]');
    if (c) { var d = c.closest('details'); if (d) d.removeAttribute('open'); }
    if (e.target.closest('[data-sheet-close]')) { var s = document.querySelector('[data-sheet]'); if (s) s.hidden = true; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var s = document.querySelector('[data-sheet]'); if (s && !s.hidden) s.hidden = true;
    var d = document.querySelector('.nav-m[open]'); if (d) d.removeAttribute('open');
  });

  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var slides = pdp.querySelectorAll('[data-slide]');
    var thumbs = pdp.querySelectorAll('[data-thumb]');
    var count = pdp.querySelector('[data-count]');
    var sticker = pdp.querySelector('[data-sticker]');
    var cur = 0;
    var show = function (i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== cur; });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === cur); t.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
      if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
      if (sticker) sticker.hidden = slides[cur].hasAttribute('data-info');
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var main = pdp.querySelector('[data-main]'), x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      });
    }
    show(0);

    var form = pdp.querySelector('[data-pdp-form]');
    if (form) {
      var out = pdp.querySelector('[data-price-out]');
      var sp = document.querySelector('[data-sticky-price]');
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name !== 'id') return;
        if (out) out.textContent = t.getAttribute('data-price');
        if (sp) sp.textContent = t.getAttribute('data-price');
        document.querySelectorAll('[data-for]').forEach(function (el) { el.hidden = el.getAttribute('data-for') !== t.value; });
        try { var u = new URL(window.location.href); u.searchParams.set('variant', t.value); history.replaceState(null, '', u); } catch (err) {}
      });
      form.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qty]');
        if (!b) return;
        var i = form.querySelector('[data-qty-in]');
        var v = (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
        i.value = Math.max(1, Math.min(20, v));
      });
      var gift = form.querySelector('.gift');
      if (gift) gift.addEventListener('toggle', function () {
        gift.querySelectorAll('[data-gift]').forEach(function (f) { f.disabled = !gift.open; });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add]'), label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (c) {
            document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
            var s = document.querySelector('[data-sheet]');
            if (s) { s.hidden = false; var f = s.querySelector('.x'); if (f) f.focus(); }
          })
          .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'); })
          .finally(function () { btn.disabled = false; btn.textContent = label; });
      });
    }
    var sticky = document.querySelector('[data-sticky]'), add = pdp.querySelector('[data-add]');
    if (sticky && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }).observe(add);
    }
  }

  var co = document.querySelector('[data-cutoff]');
  if (co && window.Intl) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', hour: '2-digit', minute: '2-digit', weekday: 'short', hour12: false }).formatToParts(new Date());
      var get = function (t) { var p = parts.filter(function (x) { return x.type === t; })[0]; return p ? p.value : ''; };
      var left = 15 * 60 - (parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10));
      if (!/Sat|Sun/.test(get('weekday')) && left > 0) {
        co.textContent = 'Bestellst du in ' + Math.floor(left / 60) + ' Std. ' + (left % 60) + ' Min., verschicken wir noch heute.';
      }
    } catch (err) {}
  }
})();

/* Announcement bar (live dispatch countdown + rotation) and the home "Fahrplan".
   Dispatch rule: weekdays (Mon-Fri) except the days listed in the header setting, cut-off 15:00 Europe/Vienna.
   Formatting matches assets/ck-orig.js so the product page and home page say the same thing. */
(function () {
  'use strict';
  var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var MO = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  var CUT = 15 * 60, SPAN = { AT: [1, 2], DE: [2, 3] }, NAME = { AT: 'Österreich', DE: 'Deutschland' };
  var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  var offEl = document.querySelector('[data-ck-off]');
  var off = ((offEl && offEl.getAttribute('data-ck-off')) || '').split(/[\s,;]+/).filter(function (x) { return /^\d{4}-\d{2}-\d{2}$/.test(x); });
  var iso = function (d) { return d.toISOString().slice(0, 10); };
  var nowVienna = function () {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (t) { var x = parts.filter(function (p) { return p.type === t; })[0]; return x ? parseInt(x.value, 10) : 0; };
      return { d: new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), min: (g('hour') % 24) * 60 + g('minute') };
    } catch (e) {
      var n = new Date();
      return { d: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), min: n.getHours() * 60 + n.getMinutes() };
    }
  };
  var work = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && off.indexOf(iso(d)) < 0; };
  var addWork = function (d, n) { var x = new Date(d.getTime()), guard = 0; while (n > 0 && guard++ < 60) { x.setUTCDate(x.getUTCDate() + 1); if (work(x)) n--; } return x; };
  var dm = function (d) { return d.getUTCDate() + '. ' + MO[d.getUTCMonth()]; };
  var wdm = function (d) { return WD[d.getUTCDay()] + ', ' + dm(d); };
  var span = function (a, b) {
    if (a.getTime() === b.getTime()) return wdm(a);
    return a.getUTCMonth() === b.getUTCMonth()
      ? WD[a.getUTCDay()] + ' ' + a.getUTCDate() + '.–' + WD[b.getUTCDay()] + ' ' + dm(b)
      : WD[a.getUTCDay()] + ' ' + dm(a) + ' – ' + WD[b.getUTCDay()] + ' ' + dm(b);
  };
  var left = function (m) { var h = Math.floor(m / 60), mm = m % 60; return (h ? h + ' Std. ' : '') + mm + ' Min.'; };
  var when = function (ship, base) {
    var days = Math.round((ship - base) / 864e5);
    if (days <= 0) return 'heute';
    if (days === 1) return 'morgen';
    if (days < 7) return 'am ' + WDL[ship.getUTCDay()];
    return 'am ' + dm(ship);
  };
  var state = function () {
    var n = nowVienna(), today = work(n.d) && n.min < CUT;
    return { n: n, today: today, ship: today ? n.d : addWork(n.d, 1), left: CUT - n.min };
  };
  // Exposed for QA only (e.g. checking the weekend and holiday rules in the console).
  window.ckShip = { state: state, addWork: addWork, work: work };

  /* Announcement bar */
  var ann = document.querySelector('[data-ck-ann]');
  if (ann) {
    var wide = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : { matches: true };
    var cd = ann.hasAttribute('data-ck-countdown') ? ann.querySelector('[data-ck-cutoff]') : null;
    var renderAnn = function () {
      if (!cd) return;
      var s = state();
      if (s.today) cd.textContent = (wide.matches ? 'Heute verschickt: noch ' : 'Versand heute: noch ') + left(s.left);
      else cd.textContent = 'Jetzt bestellen, ' + (wide.matches ? when(s.ship, s.n.d) + ' verschickt' : 'Versand ' + when(s.ship, s.n.d));
    };
    renderAnn();
    window.setInterval(renderAnn, 30000);

    var items = Array.prototype.slice.call(ann.querySelectorAll('[data-ck-ann-item]'));
    var btn = ann.querySelector('[data-ck-ann-pause]');
    var idx = 0, timer = 0, userPaused = false, held = false;
    var show = function (i) { idx = i; items.forEach(function (el, k) { el.classList.toggle('on', k === i); }); };
    var stop = function () { if (timer) window.clearInterval(timer); timer = 0; };
    var start = function () {
      stop();
      if (calm || wide.matches || items.length < 2 || userPaused || held || document.hidden) return;
      timer = window.setInterval(function () { show((idx + 1) % items.length); }, 5000);
    };
    var onWide = function () { renderAnn(); start(); };
    if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
    if (items.length > 1 && !calm) {
      if (btn) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          userPaused = !userPaused;
          btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          btn.setAttribute('aria-label', userPaused ? 'Wechselnde Hinweise fortsetzen' : 'Wechselnde Hinweise anhalten');
          start();
        });
      }
      ann.addEventListener('mouseenter', function () { held = true; stop(); });
      ann.addEventListener('mouseleave', function () { held = false; start(); });
      ann.addEventListener('focusin', function () { held = true; stop(); });
      ann.addEventListener('focusout', function (e) { if (!ann.contains(e.relatedTarget)) { held = false; start(); } });
      document.addEventListener('visibilitychange', start);
      start();
    }
  }

  /* Delivery "Fahrplan" */
  var plan = document.querySelector('[data-ck-plan]');
  if (plan) {
    var country = plan.getAttribute('data-c') === 'DE' ? 'DE' : 'AT';
    var saved = store.get('om-c'); if (saved === 'AT' || saved === 'DE') country = saved;
    var T = function (k) { return plan.querySelector('[data-ck-t="' + k + '"]'); };
    var put = function (k, v) { var el = T(k); if (el) el.textContent = v; };
    var buttons = Array.prototype.slice.call(plan.querySelectorAll('[data-ck-plan-c]'));
    var renderPlan = function () {
      var s = state(), sp = SPAN[country], a = addWork(s.ship, sp[0]), b = addWork(s.ship, sp[1]);
      put('order', s.today ? 'Heute bis 15 Uhr' : 'Jetzt');
      put('order-s', s.today ? 'noch ' + left(s.left) : 'Versand ' + when(s.ship, s.n.d));
      var os = T('order-s'); if (os) os.classList.toggle('plan-live', s.today);
      put('ship', (s.today ? 'Heute, ' : '') + wdm(s.ship));
      put('arrive-k', 'Bei dir in ' + NAME[country]);
      put('arrive', span(a, b));
      put('arrive-s', 'voraussichtlich, ' + sp[0] + '–' + sp[1] + ' Werktage');
      buttons.forEach(function (bt) { bt.setAttribute('aria-pressed', bt.getAttribute('data-ck-plan-c') === country ? 'true' : 'false'); });
    };
    var sw = plan.querySelector('[data-ck-plan-sw]'); if (sw) sw.hidden = false;
    buttons.forEach(function (bt) {
      bt.addEventListener('click', function () { country = bt.getAttribute('data-ck-plan-c'); store.set('om-c', country); renderPlan(); });
    });
    renderPlan();
    window.setInterval(renderPlan, 30000);
  }
})();
